import React from "react";
import Image from "next/future/image";
import UseCasesCarousel from "./UseCasesCarosel";
import { Section2 } from "./Constants";

const CollegeFestsAndCulturalEvents = ({ title }) => {
  return (
    <>
      <div
        className={`${title}-root d-flex justify-content-center align-items-center flex-row px-5 px-mob  pt-4 pb-5 g-0`}
      >
        <div className={`row`}>
          <div
            className={`col-lg-6 col pb-md-3 pt-md-5 px-md-3 py-3 px-lg-3 ps-lg-5 ${title}-details-root`}
          >
            <h2 className={`${title}-title`}>
              College Fests & Cultural Events
              {/* <span><Image src={Chain} alt="link" /></span> */}
            </h2>
            <div className={`${title}-text mt-1`}>
              KonfHub streamlines academic tech festivals
            </div>
            <div
              className={`mx-md-5 desktop-none d-flex justify-content-center align-items-center px-md-3`}
            >
              <Image
                className={`${title}-RootImageDesktop`}
                src="/img/useCases/CollegeFestAndCulturalEvents.png"
                alt="TechFestAndHackathonsImg"
                width={320}
                height={320}
              />
            </div>
            <div className={`${title}-subText mt-md-4`}>
              Academic technology festivals are no easy feat, especially with a large number of participants. Luckily, KonfHub comes to the rescue
              by providing effective features for overcoming the many challenges
              involved in organizing such events.
              <ul>
                <li>Efficiently manage multiple tickets and discount codes</li>
                <li>
                  Generate combined tickets for participants purchasing multiple
                  event tickets
                </li>
                <li>
                  Seamlessly manage hundreds or thousands of attendees with the
                  check-in app at registration desks
                </li>
                <li>
                  Reward participants with participation certificates and gather
                  valuable feedback
                </li>
              </ul>
            </div>
          </div>
          <div
            className={`col-lg-6 mob-none col py-md-3 d-flex justify-content-center flex-column align-items-center px-md-3 ps-lg-5 pe-lg-5 py-`}
          >
            <div
              className={`mx-md-5 d-flex justify-content-center align-items-center px-md-3`}
            >
              <Image
                className={`${title}-RootImageDesktop`}
                src="/img/useCases/CollegeFestAndCulturalEvents.png"
                alt="TechFestAndHackathonsImg"
                width={550}
                height={550}
              />
            </div>
          </div>
          <UseCasesCarousel data={Section2} />
        </div>
      </div>
      <style jsx>
        {`
          .${title}-root {
            background: #f6f9fc;
            padding: 50px 0px;
            padding-left: 105px;
            padding-right: 105px;
          }
          .${title}-root .${title}-details-root {
            padding-right: 10px;
          }
          .${title}-root .${title}-details-root .${title}-title {
            font-family: "Nunito";
            font-weight: 800;
            font-size: 42px;
            line-height: 57px;
            color: #572148;
          }
          .desktop-none {
            display: none !important;
          }
          .${title}-root .${title}-details-root .${title}-text {
            font-family: "Nunito";
            font-weight: 700;
            font-size: 22px;
            line-height: 30px;
            text-align: left;
            color: #616161;
          }
          .${title}-root ${title}-RootImageDesktop {
            max-width: 100%;
          }
          .${title}-root .${title}-details-root .${title}-subText {
            font-family: "Nunito";
            font-weight: 500;
            font-size: 18px;
            line-height: 27px;
            color: #4f4f4f;
          }
          .${title}-root .${title}-details-root .${title}-subText ul {
            margin-bottom: 0px !important;
          }
          @media screen and (max-width: 722px) {
            .${title}-root {
              padding-left: 50px;
              padding-right: 50px;
            }
          }
          /* LG screens */
          @media only screen and (max-width: 992px) {
            .mob-none {
              display: none !important;
            }
            .desktop-none {
              display: flex !important;
            }
          }
          @media screen and (max-width: 679px) {
            .${title}-root {
              padding-left: 30px;
              padding-right: 30px;
            }
            .${title}-root .${title}-details-root {
              padding-right: 0px;
            }
          }
          @media screen and (max-width: 480px) {
            .${title}-root {
              padding-left: 20px;
              padding-right: 20px;
              padding-top: 30px;
              padding-bottom: 0px;
            }
            .${title}-root .${title}-details-root {
              padding-right: 10px;
              display: flex;
              flex-direction: column;
              align-items: start;
            }
            .${title}-root .${title}-details-root .${title}-title {
              font-weight: 800;
              font-size: 24px;
              line-height: 33px;
            }
            .${title}-root .${title}-details-root .${title}-text {
              font-weight: 700;
              font-size: 14px;
              line-height: 19px;
              width: 80%;
            }
            .${title}-root .${title}-details-root .${title}-subText {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
            }
          }
        `}
      </style>
    </>
  );
};

export default CollegeFestsAndCulturalEvents;
